var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang && _vm.lang.labels
    ? _c("div", { staticClass: "estates-list-menu" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row max-500" }, [
            _c("div", { staticClass: "col-auto pr-0" }, [
              _c(
                "button",
                {
                  staticClass: "btn whitecta",
                  on: { click: _vm.toggleListingView }
                },
                [
                  _c("masked-image", {
                    attrs: {
                      src: "/img/icons/" + _vm.$root.network + "/maps.svg"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showMap ? _vm.lang.labels.list : _vm.lang.labels.map
                      ) +
                      "\n                "
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-network",
                  on: { click: _vm.openSaveSearchModal }
                },
                [_c("span", [_vm._v(_vm._s(_vm.lang.labels.save_search))])]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }